module.exports = __webpack_public_path__ + "img/folder-yellow.d553d1c6.svg";